
import CryptoJS from 'crypto-js';

export default function interceptorRequestAxios(request) {
    try {
        const pathNoEncrypt = ['payment', 'commissions'];
        const path = request.url.split('/')[0] ? request.url.split('/')[0] : request.url.split('/')[1];

        if(request.data && !pathNoEncrypt.includes(path)){
            request.data = { encryptZeloCriptografia: CryptoJS.AES.encrypt(JSON.stringify(request.data), process.env.REACT_APP_KEYCRYPTO).toString() };
        }

        return request;
    } catch (err) {
        console.log(err);
    }
}
